


export const getDefaultType = (modules: string[], role: string) => {

    if (modules.includes("1") && modules.includes("2") ) {
        return "both";
    } else if (modules.includes("2")) {
        return "ocean";
    }
    else if (modules.includes("1")) {
        return "air";
    }
    return "air";
};
export const getDefaultService = (modules: string[], role: string) => {

    if (modules.includes("1")) {
        return "air";
    } else if (modules.includes("2")) {
        return "ocean";
    }
    return "air";
};